import React, {
  memo,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Container, Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import WinLinesController from "./WinLinesController";
import { safeInit } from "../../../utilities";
import { Settings } from "../../../settings";

const WinLinesContainer = memo(
  forwardRef(({ symbolWidth, symbolHeight, dividerDimensions }, ref) => {
    const containerRef = useRef(null);
    const controllerRef = useRef(null);

    // Initialize controller after container and children are ready
    useEffect(() => {
      if (!containerRef.current || controllerRef.current) return;

      safeInit(() => {
        controllerRef.current = new WinLinesController(
          containerRef.current,
          symbolWidth,
          symbolHeight,
          dividerDimensions
        );
      });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Handle resize
    useEffect(() => {
      if (controllerRef.current?.isReady()) {
        controllerRef.current.updateDimensionsAndRescale(
          symbolWidth,
          symbolHeight,
          dividerDimensions
        );
      }
    }, [symbolHeight]); // eslint-disable-line react-hooks/exhaustive-deps

    // Expose controller methods
    useImperativeHandle(ref, () => ({
      getWinLinesController: () => controllerRef.current,
      showWinLine: (lineId) => controllerRef.current?.showWinLine(lineId),
      showMultipleWinLines: (lineIds) =>
        controllerRef.current?.showMultipleWinLines(lineIds),
      hideWinLine: () => controllerRef.current?.hideWinLine(),
    }));

    return (
      <Container ref={containerRef} name="win_lines_overlay" zIndex={4}>
        <Sprite
          texture={PIXI.Texture.EMPTY}
          width={symbolWidth * Settings.REEL_COUNT}
          height={symbolHeight * Settings.SYMBOLS_VISIBLE}
          anchor={0.5}
          name="win_lines_overlay_placeholder"
        />
      </Container>
    );
  })
);

export default WinLinesContainer;
